
<div [ngClass]="{'float-window': pageOrigin == 'add-content-spliting'}">
    <div class="float-header">
        <button mat-icon-button (click)="closeWindow()">
            <mat-icon>close</mat-icon>
        </button>
        <!-- <button mat-icon-button (click)="reloadWindow()">
            <mat-icon>refresh</mat-icon>
        </button> -->
    </div>
    <div *ngIf="pageOrigin == 'add-content-spliting' ">
        <app-pdf-viewer [pageOrigin]="pageOrigin" [userInfos]="userInfos" [pdfData]="pdfData" (callBackEvent)="callBackEventEmiter($event)" class="pdf-container"></app-pdf-viewer>
    </div>
    <div style="width: 150px; ">
            <mat-select placeholder="Document" [formControl]="switchControl" (selectionChange)="switchDocument()">
                <mat-option [value]="'pdf-show'">Show PDF</mat-option>
                <mat-option [value]="'docx-show'">Show Docx</mat-option>
                <mat-option *ngIf="userInfos['privilege'] >= 2" [value]="'docx-edit'">Edit Docx</mat-option>
            </mat-select>
        </div>
    <div *ngIf="pageOrigin == 'show-editor-pdf' ">
        
        <div *ngIf="showMode != 'pdf-show'" style="padding: 15px; height: 80vh; ">
            <div id="editor-container"></div>
        </div> 
        <app-pdf-viewer *ngIf="showMode == 'pdf-show'" [pageOrigin]="pageOrigin" [userInfos]="userInfos" [pdfData]="pdfData" (callBackEvent)="callBackEventEmiter($event)" class="pdf-container"></app-pdf-viewer>
    </div>

    <div *ngIf="pageOrigin == 'show-editor-docx' ">
        
        <div *ngIf="showMode != 'pdf-show'" style="padding: 15px; height: 80vh; ">
            <div id="editor-container"></div>
        </div> 
    </div>
</div>